import { CategoryModel } from '../Model/CategoryModel'

export const categoriesList: CategoryModel[] = [
    {
        id: 1,
        name: 'Pretend Play',
        url: '/images/popular-toys-photos/dolltoy.webp',
        route: 'products/pretend play',
    },
    {
        id: 2,
        name: 'Baby Shaker',
        url: '/images/popular-toys-photos/star-shaker.png',
        route: 'products/baby shakers',
    },
    {
        id: 3,
        name: 'Construction',
        url: '/images/popular-toys-photos/mathtoy.webp',
        route: 'products/construction',
    },
    {
        id: 4,
        name: 'Kitchen',
        url: '/images/popular-toys-photos/eggset.webp',
        route: 'products/kitchen',
    },
    {
        id: 5,
        name: 'Carpentry',
        url: '/images/popular-toys-photos/toychair.webp',
        route: 'products/pretend play',
    },
]
